import type { ReactElement } from 'react';

import EmailIcon from '@app/components/icons/email';
import PhoneIcon from '@app/components/icons/phone';
import Tooltip from '@app/components/tooltip';

import style from './position-tooltip.module.scss';

type PositionTooltipProps = {
  position:
    | Oneflow.Position
    | {
        id: number;
        fullname: string;
        email?: string;
        phoneNumber?: string;
      };
  children: ReactElement;
};

export const PositionTooltip = ({ position, children }: PositionTooltipProps) => {
  const { fullname, email, phoneNumber } = position;

  const renderTooltipMessage = () => (
    <div>
      <div className={style.PositionName}>{fullname}</div>
      {email && (
        <div className={style.PositionEmail}>
          <EmailIcon height="14px" />
          <span>{email}</span>
        </div>
      )}
      {phoneNumber && (
        <div className={style.PositionPhoneNumber}>
          <PhoneIcon height="14px" />
          <span>{phoneNumber}</span>
        </div>
      )}
    </div>
  );

  return (
    <Tooltip
      key={position.id}
      side="top"
      message={renderTooltipMessage()}
      messageClassName={style.PositionTooltipMessage}
      triggerClassName={style.PositionTooltipTrigger}
    >
      {children}
    </Tooltip>
  );
};
